// eslint-disable-next-line no-extend-native
Date.prototype.Format = function (fmt) {
  fmt = fmt || 'yyyy-MM-dd hh:mm:ss'
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    'S': this.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  // eslint-disable-next-line eqeqeq
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
  }
  return fmt
}
// eslint-disable-next-line no-extend-native
Date.prototype.myUTCFormat = function (format) {
  format = format || 'yyyy-MM-ddThh:mm:ssZ'
  var timeFormat = {
    'M+': this.getMonth() + 1, // month
    'd+': this.getDate(), // day
    'h+': (format === 'yyyy-MM-ddThh:mm:ssZ' ? this.getHours() - 8 : this.getHours()), // hour 是否是UTC时间
    'm+': this.getMinutes(), // minute
    's+': this.getSeconds(), // second
    'q+': Math.floor((this.getMonth() + 3) / 3), // quarter
    'S': this.getMilliseconds() // millisecond
  }
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in timeFormat) {
    // eslint-disable-next-line eqeqeq
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? timeFormat[k] : ('00' + timeFormat[k]).substr(('' + timeFormat[k]).length))
    }
  }
  return format
}
import $ from 'jquery'

export default ({
  // eslint-disable-next-line no-unused-vars
  urlParam: function (url) {
    // 使用正则来 两边的参数不可能是 &=? 所以去反集[^&=?]
    // eslint-disable-next-line one-var
    let regex = /([^&=?]+)=([^&=?]+)/g,
      obj = {}
    url.replace(regex, (...arg) => {
      obj[arg[1]] = decodeURIComponent(arg[2])
    })
    return obj || ''
  },
  // 处理空格显示
  parseSpace: function (value) {
    if (!value) return value
    return value.replace(/[\r\n]/g, '<br>').replace(/[\s\t\b]/g, '&nbsp;')
  },
  // 评论数、点赞数、阅读数 数解析 parseCount
  parseCount: function (num) {
    if (!isNaN(num) && num) {
      if (num >= 10000) {
        try {
          // 第三位向上进位
          // var curNum = (Math.ceil(num / 1000) / 10).toFixed(1).replace(/\.0$/, '');
          // 舍取后三位
          var curNum = (parseInt(num / 1000) / 10).toFixed(1).replace(/\.0$/, '')
          return isNaN(curNum) ? num : curNum + '万'
        } catch (e) {
          return (num + '').replace(/\.0$/, '')
        }
      } else {
        return (num + '').replace(/\.0$/, '')
      }
    } else {
      return 0
    }
  },
  // 处理日期时间
  parseDateTime: function (hisTime) {
    if (!arguments.length) return ''
    try {
      // eslint-disable-next-line one-var
      let arg = arguments,
        now = arg[1] ? arg[1] : new Date().getTime(),
        diffValue = now - new Date(arg[0].replace(/-/g, '/')).getTime(),
        cur = new Date(arg[0].replace(/-/g, '/')).getTime(),
        result = '',
        minute = 1000 * 60,
        hour = minute * 60,
        day = hour * 24,
        // eslint-disable-next-line no-unused-vars
        halfamonth = day * 15,
        month = day * 30,
        year = month * 12,
        // eslint-disable-next-line no-unused-vars
        _year = diffValue / year,
        _month = diffValue / month,
        _week = diffValue / (7 * day),
        _day = diffValue / day,
        _hour = diffValue / hour,
        _min = diffValue / minute
      // eslint-disable-next-line eqeqeq
      if (new Date(cur).getFullYear() == new Date().getFullYear()) {
        if (_month >= 1 || _week >= 1 || _day >= 3) {
          result = new Date(cur).Format('MM-dd')
        } else if (_day >= 1) {
          result = parseInt(_day) + '天前'
        } else if (_hour >= 1) {
          result = parseInt(_hour) + '小时前'
        } else if (_min >= 1) {
          result = parseInt(_min) + '分钟前'
        } else {
          result = '刚刚'
        }
        return result
      } else {
        return new Date(cur).Format('yyyy-MM-dd')
      }
    } catch (e) {
      return hisTime
    }
  },
  // 获取url Param
  getUrlParam: function (param) { // 解析url参数
    // eslint-disable-next-line no-useless-escape
    var sValue = window.location.href.match(new RegExp('[\?\&]' + param + '=([^\&]*)(\&?)', 'i'))
    return sValue ? sValue[1] : sValue
  },
  SHA_UUID_MD: {
    HEX_SHA1: function (s) {
      var hexcase = 0
      /* hex output format. 0 - lowercase; 1 - uppercase     */
      var b64pad = ''
      /* base-64 pad character. "=" for strict RFC compliance  */
      var chrsz = 8
      /* bits per input character. 8 - ASCII; 16 - Unicode    */

      // function hex_sha1(s) {
      //     return binb2hex(core_sha1(str2binb(s), s.length * chrsz));
      // }
      // eslint-disable-next-line camelcase,no-unused-vars
      function b64_sha1 (s) {
        return binb2b64(core_sha1(str2binb(s), s.length * chrsz))
      }

      // eslint-disable-next-line camelcase,no-unused-vars
      function str_sha1 (s) {
        return binb2str(core_sha1(str2binb(s), s.length * chrsz))
      }

      // eslint-disable-next-line camelcase,no-unused-vars
      function hex_hmac_sha1 (key, data) {
        return binb2hex(core_hmac_sha1(key, data))
      }

      // eslint-disable-next-line camelcase,no-unused-vars
      function b64_hmac_sha1 (key, data) {
        return binb2b64(core_hmac_sha1(key, data))
      }

      // eslint-disable-next-line camelcase,no-unused-vars
      function str_hmac_sha1 (key, data) {
        return binb2str(core_hmac_sha1(key, data))
      }

      // eslint-disable-next-line camelcase,no-unused-vars
      function sha1_vm_test () {
        // eslint-disable-next-line eqeqeq,no-undef
        return hex_sha1('abc') == 'a9993e364706816aba3e25717850c26c9cd0d89d'
      }

      // eslint-disable-next-line camelcase
      function core_sha1 (x, len) {
        /* append padding */
        x[len >> 5] |= 0x80 << (24 - len % 32)
        x[((len + 64 >> 9) << 4) + 15] = len
        var w = Array(80)
        var a = 1732584193
        var b = -271733879
        var c = -1732584194
        var d = 271733878
        var e = -1009589776
        for (var i = 0; i < x.length; i += 16) {
          var olda = a
          var oldb = b
          var oldc = c
          var oldd = d
          var olde = e
          for (var j = 0; j < 80; j++) {
            if (j < 16) {
              w[j] = x[i + j]
            } else {
              w[j] = rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1)
            }
            var t = safe_add(safe_add(rol(a, 5), sha1_ft(j, b, c, d)), safe_add(safe_add(e, w[j]), sha1_kt(j)))
            e = d
            d = c
            c = rol(b, 30)
            b = a
            a = t
          }
          a = safe_add(a, olda)
          b = safe_add(b, oldb)
          c = safe_add(c, oldc)
          d = safe_add(d, oldd)
          e = safe_add(e, olde)
        }
        // eslint-disable-next-line no-array-constructor
        return Array(a, b, c, d, e)
      }

      // eslint-disable-next-line camelcase
      function sha1_ft (t, b, c, d) {
        if (t < 20) return (b & c) | ((~b) & d)
        if (t < 40) return b ^ c ^ d
        if (t < 60) return (b & c) | (b & d) | (c & d)
        return b ^ c ^ d
      }

      // eslint-disable-next-line camelcase
      function sha1_kt (t) {
        return (t < 20) ? 1518500249 : (t < 40) ? 1859775393 : (t < 60) ? -1894007588 : -899497514
      }

      // eslint-disable-next-line camelcase
      function core_hmac_sha1 (key, data) {
        var bkey = str2binb(key)
        if (bkey.length > 16) bkey = core_sha1(bkey, key.length * chrsz)
        // eslint-disable-next-line one-var
        var ipad = Array(16),
          opad = Array(16)
        for (var i = 0; i < 16; i++) {
          ipad[i] = bkey[i] ^ 0x36363636
          opad[i] = bkey[i] ^ 0x5C5C5C5C
        }
        var hash = core_sha1(ipad.concat(str2binb(data)), 512 + data.length * chrsz)
        return core_sha1(opad.concat(hash), 512 + 160)
      }

      // eslint-disable-next-line camelcase
      function safe_add (x, y) {
        var lsw = (x & 0xFFFF) + (y & 0xFFFF)
        var msw = (x >> 16) + (y >> 16) + (lsw >> 16)
        return (msw << 16) | (lsw & 0xFFFF)
      }

      function rol (num, cnt) {
        return (num << cnt) | (num >>> (32 - cnt))
      }

      function str2binb (str) {
        // eslint-disable-next-line no-array-constructor
        var bin = Array()
        var mask = (1 << chrsz) - 1
        for (var i = 0; i < str.length * chrsz; i += chrsz) {
          bin[i >> 5] |= (str.charCodeAt(i / chrsz) & mask) << (24 - i % 32)
        }
        return bin
      }

      function binb2str (bin) {
        var str = ''
        var mask = (1 << chrsz) - 1
        for (var i = 0; i < bin.length * 32; i += chrsz) {
          str += String.fromCharCode((bin[i >> 5] >>> (24 - i % 32)) & mask)
        }
        return str
      }

      function binb2hex (binarray) {
        // eslint-disable-next-line camelcase
        var hex_tab = hexcase ? '0123456789ABCDEF' : '0123456789abcdef'
        var str = ''
        for (var i = 0; i < binarray.length * 4; i++) {
          str += hex_tab.charAt((binarray[i >> 2] >> ((3 - i % 4) * 8 + 4)) & 0xF) + hex_tab.charAt((binarray[i >> 2] >> ((3 - i % 4) * 8)) & 0xF)
        }
        return str
      }

      function binb2b64 (binarray) {
        var tab = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
        var str = ''
        for (var i = 0; i < binarray.length * 4; i += 3) {
          var triplet = (((binarray[i >> 2] >> 8 * (3 - i % 4)) & 0xFF) << 16) | (((binarray[i + 1 >> 2] >> 8 * (3 - (i + 1) % 4)) & 0xFF) << 8) | ((binarray[i + 2 >> 2] >> 8 * (3 - (i + 2) % 4)) & 0xFF)
          for (var j = 0; j < 4; j++) {
            if (i * 8 + j * 6 > binarray.length * 32) {
              str += b64pad
            } else {
              str += tab.charAt((triplet >> 6 * (3 - j)) & 0x3F)
            }
          }
        }
        return str
      }

      return binb2hex(core_sha1(str2binb(s), s.length * chrsz))
    },
    UUID: function () {
      var d = new Date().getTime()
      var _ss = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        // eslint-disable-next-line eqeqeq
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16)
      })
      return _ss
    },
    MD5: function (string) {
      // eslint-disable-next-line camelcase
      function md5_RotateLeft (lValue, iShiftBits) {
        return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits))
      }

      // eslint-disable-next-line camelcase
      function md5_AddUnsigned (lX, lY) {
        var lX4, lY4, lX8, lY8, lResult
        lX8 = (lX & 0x80000000)
        lY8 = (lY & 0x80000000)
        lX4 = (lX & 0x40000000)
        lY4 = (lY & 0x40000000)
        lResult = (lX & 0x3FFFFFFF) + (lY & 0x3FFFFFFF)
        if (lX4 & lY4) {
          return (lResult ^ 0x80000000 ^ lX8 ^ lY8)
        }
        if (lX4 | lY4) {
          if (lResult & 0x40000000) {
            return (lResult ^ 0xC0000000 ^ lX8 ^ lY8)
          } else {
            return (lResult ^ 0x40000000 ^ lX8 ^ lY8)
          }
        } else {
          return (lResult ^ lX8 ^ lY8)
        }
      }

      // eslint-disable-next-line camelcase
      function md5_F (x, y, z) {
        return (x & y) | ((~x) & z)
      }

      // eslint-disable-next-line camelcase
      function md5_G (x, y, z) {
        return (x & z) | (y & (~z))
      }

      // eslint-disable-next-line camelcase
      function md5_H (x, y, z) {
        return (x ^ y ^ z)
      }

      // eslint-disable-next-line camelcase
      function md5_I (x, y, z) {
        return (y ^ (x | (~z)))
      }

      // eslint-disable-next-line camelcase
      function md5_FF (a, b, c, d, x, s, ac) {
        a = md5_AddUnsigned(a, md5_AddUnsigned(md5_AddUnsigned(md5_F(b, c, d), x), ac))
        return md5_AddUnsigned(md5_RotateLeft(a, s), b)
      }

      // eslint-disable-next-line camelcase
      function md5_GG (a, b, c, d, x, s, ac) {
        a = md5_AddUnsigned(a, md5_AddUnsigned(md5_AddUnsigned(md5_G(b, c, d), x), ac))
        return md5_AddUnsigned(md5_RotateLeft(a, s), b)
      }

      // eslint-disable-next-line camelcase
      function md5_HH (a, b, c, d, x, s, ac) {
        a = md5_AddUnsigned(a, md5_AddUnsigned(md5_AddUnsigned(md5_H(b, c, d), x), ac))
        return md5_AddUnsigned(md5_RotateLeft(a, s), b)
      }

      // eslint-disable-next-line camelcase
      function md5_II (a, b, c, d, x, s, ac) {
        a = md5_AddUnsigned(a, md5_AddUnsigned(md5_AddUnsigned(md5_I(b, c, d), x), ac))
        return md5_AddUnsigned(md5_RotateLeft(a, s), b)
      }

      // eslint-disable-next-line camelcase
      function md5_ConvertToWordArray (string) {
        var lWordCount
        var lMessageLength = string.length
        // eslint-disable-next-line camelcase
        var lNumberOfWords_temp1 = lMessageLength + 8
        // eslint-disable-next-line camelcase
        var lNumberOfWords_temp2 = (lNumberOfWords_temp1 - (lNumberOfWords_temp1 % 64)) / 64
        // eslint-disable-next-line camelcase
        var lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16
        var lWordArray = Array(lNumberOfWords - 1)
        var lBytePosition = 0
        var lByteCount = 0
        while (lByteCount < lMessageLength) {
          lWordCount = (lByteCount - (lByteCount % 4)) / 4
          lBytePosition = (lByteCount % 4) * 8
          lWordArray[lWordCount] = (lWordArray[lWordCount] | (string.charCodeAt(lByteCount) << lBytePosition))
          lByteCount++
        }
        lWordCount = (lByteCount - (lByteCount % 4)) / 4
        lBytePosition = (lByteCount % 4) * 8
        lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition)
        lWordArray[lNumberOfWords - 2] = lMessageLength << 3
        lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29
        return lWordArray
      }

      // eslint-disable-next-line camelcase
      function md5_WordToHex (lValue) {
        // eslint-disable-next-line camelcase,one-var
        var WordToHexValue = '', WordToHexValue_temp = '', lByte, lCount
        for (lCount = 0; lCount <= 3; lCount++) {
          lByte = (lValue >>> (lCount * 8)) & 255
          // eslint-disable-next-line camelcase
          WordToHexValue_temp = '0' + lByte.toString(16)
          WordToHexValue = WordToHexValue + WordToHexValue_temp.substr(WordToHexValue_temp.length - 2, 2)
        }
        return WordToHexValue
      }

      // eslint-disable-next-line camelcase
      function md5_Utf8Encode (string) {
        string = string.replace(/\r\n/g, '\n')
        var utftext = ''
        for (var n = 0; n < string.length; n++) {
          var c = string.charCodeAt(n)
          if (c < 128) {
            utftext += String.fromCharCode(c)
          } else if ((c > 127) && (c < 2048)) {
            utftext += String.fromCharCode((c >> 6) | 192)
            utftext += String.fromCharCode((c & 63) | 128)
          } else {
            utftext += String.fromCharCode((c >> 12) | 224)
            utftext += String.fromCharCode(((c >> 6) & 63) | 128)
            utftext += String.fromCharCode((c & 63) | 128)
          }
        }
        return utftext
      }

      // eslint-disable-next-line no-array-constructor
      var x = Array()
      var k, AA, BB, CC, DD, a, b, c, d
      // eslint-disable-next-line one-var
      var S11 = 7, S12 = 12, S13 = 17, S14 = 22
      // eslint-disable-next-line one-var
      var S21 = 5, S22 = 9, S23 = 14, S24 = 20
      // eslint-disable-next-line one-var
      var S31 = 4, S32 = 11, S33 = 16, S34 = 23
      // eslint-disable-next-line one-var
      var S41 = 6, S42 = 10, S43 = 15, S44 = 21
      string = md5_Utf8Encode(string)
      x = md5_ConvertToWordArray(string)
      a = 0x67452301
      b = 0xEFCDAB89
      c = 0x98BADCFE
      d = 0x10325476
      for (k = 0; k < x.length; k += 16) {
        AA = a
        BB = b
        CC = c
        DD = d
        a = md5_FF(a, b, c, d, x[k + 0], S11, 0xD76AA478)
        d = md5_FF(d, a, b, c, x[k + 1], S12, 0xE8C7B756)
        c = md5_FF(c, d, a, b, x[k + 2], S13, 0x242070DB)
        b = md5_FF(b, c, d, a, x[k + 3], S14, 0xC1BDCEEE)
        a = md5_FF(a, b, c, d, x[k + 4], S11, 0xF57C0FAF)
        d = md5_FF(d, a, b, c, x[k + 5], S12, 0x4787C62A)
        c = md5_FF(c, d, a, b, x[k + 6], S13, 0xA8304613)
        b = md5_FF(b, c, d, a, x[k + 7], S14, 0xFD469501)
        a = md5_FF(a, b, c, d, x[k + 8], S11, 0x698098D8)
        d = md5_FF(d, a, b, c, x[k + 9], S12, 0x8B44F7AF)
        c = md5_FF(c, d, a, b, x[k + 10], S13, 0xFFFF5BB1)
        b = md5_FF(b, c, d, a, x[k + 11], S14, 0x895CD7BE)
        a = md5_FF(a, b, c, d, x[k + 12], S11, 0x6B901122)
        d = md5_FF(d, a, b, c, x[k + 13], S12, 0xFD987193)
        c = md5_FF(c, d, a, b, x[k + 14], S13, 0xA679438E)
        b = md5_FF(b, c, d, a, x[k + 15], S14, 0x49B40821)
        a = md5_GG(a, b, c, d, x[k + 1], S21, 0xF61E2562)
        d = md5_GG(d, a, b, c, x[k + 6], S22, 0xC040B340)
        c = md5_GG(c, d, a, b, x[k + 11], S23, 0x265E5A51)
        b = md5_GG(b, c, d, a, x[k + 0], S24, 0xE9B6C7AA)
        a = md5_GG(a, b, c, d, x[k + 5], S21, 0xD62F105D)
        d = md5_GG(d, a, b, c, x[k + 10], S22, 0x2441453)
        c = md5_GG(c, d, a, b, x[k + 15], S23, 0xD8A1E681)
        b = md5_GG(b, c, d, a, x[k + 4], S24, 0xE7D3FBC8)
        a = md5_GG(a, b, c, d, x[k + 9], S21, 0x21E1CDE6)
        d = md5_GG(d, a, b, c, x[k + 14], S22, 0xC33707D6)
        c = md5_GG(c, d, a, b, x[k + 3], S23, 0xF4D50D87)
        b = md5_GG(b, c, d, a, x[k + 8], S24, 0x455A14ED)
        a = md5_GG(a, b, c, d, x[k + 13], S21, 0xA9E3E905)
        d = md5_GG(d, a, b, c, x[k + 2], S22, 0xFCEFA3F8)
        c = md5_GG(c, d, a, b, x[k + 7], S23, 0x676F02D9)
        b = md5_GG(b, c, d, a, x[k + 12], S24, 0x8D2A4C8A)
        a = md5_HH(a, b, c, d, x[k + 5], S31, 0xFFFA3942)
        d = md5_HH(d, a, b, c, x[k + 8], S32, 0x8771F681)
        c = md5_HH(c, d, a, b, x[k + 11], S33, 0x6D9D6122)
        b = md5_HH(b, c, d, a, x[k + 14], S34, 0xFDE5380C)
        a = md5_HH(a, b, c, d, x[k + 1], S31, 0xA4BEEA44)
        d = md5_HH(d, a, b, c, x[k + 4], S32, 0x4BDECFA9)
        c = md5_HH(c, d, a, b, x[k + 7], S33, 0xF6BB4B60)
        b = md5_HH(b, c, d, a, x[k + 10], S34, 0xBEBFBC70)
        a = md5_HH(a, b, c, d, x[k + 13], S31, 0x289B7EC6)
        d = md5_HH(d, a, b, c, x[k + 0], S32, 0xEAA127FA)
        c = md5_HH(c, d, a, b, x[k + 3], S33, 0xD4EF3085)
        b = md5_HH(b, c, d, a, x[k + 6], S34, 0x4881D05)
        a = md5_HH(a, b, c, d, x[k + 9], S31, 0xD9D4D039)
        d = md5_HH(d, a, b, c, x[k + 12], S32, 0xE6DB99E5)
        c = md5_HH(c, d, a, b, x[k + 15], S33, 0x1FA27CF8)
        b = md5_HH(b, c, d, a, x[k + 2], S34, 0xC4AC5665)
        a = md5_II(a, b, c, d, x[k + 0], S41, 0xF4292244)
        d = md5_II(d, a, b, c, x[k + 7], S42, 0x432AFF97)
        c = md5_II(c, d, a, b, x[k + 14], S43, 0xAB9423A7)
        b = md5_II(b, c, d, a, x[k + 5], S44, 0xFC93A039)
        a = md5_II(a, b, c, d, x[k + 12], S41, 0x655B59C3)
        d = md5_II(d, a, b, c, x[k + 3], S42, 0x8F0CCC92)
        c = md5_II(c, d, a, b, x[k + 10], S43, 0xFFEFF47D)
        b = md5_II(b, c, d, a, x[k + 1], S44, 0x85845DD1)
        a = md5_II(a, b, c, d, x[k + 8], S41, 0x6FA87E4F)
        d = md5_II(d, a, b, c, x[k + 15], S42, 0xFE2CE6E0)
        c = md5_II(c, d, a, b, x[k + 6], S43, 0xA3014314)
        b = md5_II(b, c, d, a, x[k + 13], S44, 0x4E0811A1)
        a = md5_II(a, b, c, d, x[k + 4], S41, 0xF7537E82)
        d = md5_II(d, a, b, c, x[k + 11], S42, 0xBD3AF235)
        c = md5_II(c, d, a, b, x[k + 2], S43, 0x2AD7D2BB)
        b = md5_II(b, c, d, a, x[k + 9], S44, 0xEB86D391)
        a = md5_AddUnsigned(a, AA)
        b = md5_AddUnsigned(b, BB)
        c = md5_AddUnsigned(c, CC)
        d = md5_AddUnsigned(d, DD)
      }
      return (md5_WordToHex(a) + md5_WordToHex(b) + md5_WordToHex(c) + md5_WordToHex(d)).toLowerCase()
    }
  },
  getHtmlParam: function () {
    // 处理 ‘/稿件aid_租户sid.html’ 后缀且带 ‘_’ 的参数处理 返回 {aid:'稿件aid',sid:'租户sid'} /
    var htmlParam = window.location.href.match(/\/([^/]+_{1}[^/]+)(\.html)/)
    if (htmlParam && htmlParam[1].indexOf('_') > -1) {
      var p = htmlParam[1].split('_')
      return {
        aid: p[0],
        sid: p[1]
      }
    } else {
      return ''
    }
  },
  browser: function () {
    var $agent = window.navigator.userAgent
    return {
      mobile: ($agent.indexOf('Android') > -1 || $agent.indexOf('Linux') > -1 || $agent.indexOf('iPhone') > -1), // 移动设备
      ios: !!$agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      android: $agent.indexOf('Android') > -1 || $agent.indexOf('Linux') > -1, // android终端或者uc浏览器
      iPhone: $agent.indexOf('iPhone') > -1 || $agent.indexOf('Mac') > -1, // 是否为iPhone或者QQHD浏览器
      iPad: $agent.indexOf('iPad') > -1, // 是否iPad,
      myApp: $agent.indexOf('xkyApp') > -1, // 新空云APP
      isWX: $agent.indexOf('MicroMessenger') > -1 // 是否是微信
    }
  },
  timeComparison: function (time, exp) {
    if (!time || !exp) return
    var _curTime = new Date().getTime()
    exp = exp || 0
    time = time || _curTime
    // eslint-disable-next-line no-useless-escape
    time = /T/g.test(time) ? new Date(new Date(time).toString()).getTime() : new Date(time.replace(/\-/g, '/')).getTime()
    if (time + exp * 1000 * 0.9 > _curTime) {
      return true
    } else {
      return false
    }
  },
  clientWidth: screen.width || window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
  clientHeight: screen.height || window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
  videoPlayOne: function (n) {
    try {
      var videoPlayOnes = document.getElementsByTagName('video')
      for (var i = videoPlayOnes.length - 1; i >= 0; i--) {
        videoPlayOnes[i].curIndex = i
        videoPlayOnes[i].addEventListener('play', function () {
          for (var j = videoPlayOnes.length - 1; j >= 0; j--) {
            // eslint-disable-next-line eqeqeq
            if (j != this.curIndex) videoPlayOnes[j].pause()
          }
        })
      }
    } catch (e) {
      console.log(e)
    }
  },
  evokeAppInit: function (sid, topicID, discussID, topicDetailType, curId) {
    try {
      var param = {
        ti: document.title || '',
        aid: discussID || topicID,
        ty: discussID ? '105' : '104',
        id: discussID || topicID,
        sid: sid
      }
      if (!discussID) {
        param.topicDetailType = topicDetailType
        param.cid = curId || ''
      }
      console.table(param)
      if (typeof gUserConfig !== 'undefined') {
        console.log('typeof gUserConfig !== \'undefined\'')
        setTimeout(function () {
          // eslint-disable-next-line no-undef
          typeof evokeApp !== 'undefined' && typeof evokeApp.init === 'function' && evokeApp.init(param)
        }, 200)
      } else {
        $.ajaxSetup({
          cache: true
        })
        $.getScript(`https://oss.newaircloud.com/global/user/${sid}/mobile/global.js`).then(function (script, textStatus) {
          if (typeof gUserConfig !== 'undefined') {
            console.log('有没 list', typeof evokeApp !== 'undefined' && typeof evokeApp)
            // eslint-disable-next-line no-undef
            setTimeout(function () {
              // eslint-disable-next-line no-undef
              typeof evokeApp !== 'undefined' && typeof evokeApp.init === 'function' && evokeApp.init(param)
            }, 200)
          }
        })
      }
    } catch (e) {
      console.log(e)
    }
  },
  wxLaunchHtml: function (height, appid, data) {
    return `<span class="wx-launch-app-btn-outer">
              <wx-open-launch-app class="wx-launch-app-btn" ${appid && 'appid=' + appid || ''} ${data && 'extinfo=' + JSON.stringify(data) || ''} >
                <script type="text/wxtag-template">
                    <style>
                        .btn {
                            height: ${height || '100%'};
                            width: 100%;
                            display: inline-block;
                        }
                    </style>
                    <button class="btn"> App内查看 </button>
                </script>
              </wx-open-launch-app>
            </span>`
  },
  wxLaunchChange: function (container, fun, n, m, height, data, successFun) {
    try {
      // eslint-disable-next-line no-undef
      fun = fun || function () {

      }
      let _shareData = data
      try {
        if (/(apiconfigtest\.newaircloud\.com)|(http:\/\/127\.0\.0\.1)/.test(window.location.href)) {
          // eslint-disable-next-line no-undef
          console.log(_openWxLaunch, _wxOpenAppID, container)
          console.log('wxLanuchChange0', typeof fun)
        }
      } catch (e) {
        console.log(e)
      }

      // eslint-disable-next-line no-undef,no-useless-escape
      if (window.navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/) && typeof _openWxLaunch !== 'undefined' && _openWxLaunch && typeof _wxOpenAppID !== 'undefined' && _wxOpenAppID && typeof _shareData !== 'undefined' && _shareData && !n) {
        console.log('wxLanuchChange1')
        try {
          // eslint-disable-next-line eqeqeq
          if (m == 1) {
            var _p = $(container).find('.wx-launch-app-btn-parent').html()
            console.log('_p', _p, container)
            // eslint-disable-next-line no-undef
            _p && $(container).find('.wx-launch-app-btn-parent').html(_p + this.wxLaunchHtml(height || '32px', _wxOpenAppID, _shareData)).off('click').removeAttr('@click')
          }
        } catch (e) {
          console.log(e)
        }

        try {
          $(container).find('.wx-launch-app-btn').attr({
            // eslint-disable-next-line no-undef
            appid: _wxOpenAppID,
            // eslint-disable-next-line no-undef
            extinfo: JSON.stringify(_shareData)
          }).on('error', fun)
          if (typeof successFun === 'function') {
            $(container).find('.wx-launch-app-btn').on('launch', successFun)
          }
        } catch (e) {
          console.log(e)
          $(container).find('.wx-launch-app-btn-outer').remove()
          $(container).find('.wx-launch-app-btn-parent').click(fun)
        }
      } else {
        console.log('wxLanuchChange11')
        $(container).find('.wx-launch-app-btn-outer').remove()
        $(container).find('.wx-launch-app-btn-parent').click(fun)
      }
    } catch (e) {
      console.log(e)
      $(container).find('.wx-launch-app-btn-outer').remove()
      $(container).find('.wx-launch-app-btn-parent').click(fun)
    }
  },
  articleJumpUrl: function (sid, articleType, articleID, columnID, linkID, curCid) {
    columnID = columnID || 0
    linkID = linkID || 0
    //  console.log(objItem);
    var articleUrl = ''
    // 0:文章 1:组图 2:视频 3:专题 4:链接 5：多标题 6:直播 7:活动 8:广告 25 会员投稿
    // eslint-disable-next-line eqeqeq
    if (articleType == 0) {
      articleUrl = '/detailArticle/' + articleID + '_' + columnID + '_' + sid + '.html'
      // eslint-disable-next-line eqeqeq
    } else if (articleType == 1) {
      articleUrl = '/detailImage/' + articleID + '_' + columnID + '_' + sid + '.html'
      // eslint-disable-next-line eqeqeq
    } else if (articleType == 2) {
      articleUrl = '/detailArticle/' + articleID + '_' + columnID + '_' + sid + '.html'
      // eslint-disable-next-line eqeqeq
    } else if (articleType == 3) {
      articleUrl = '/special_detail?newsid=' + articleID + '_' + sid
      // eslint-disable-next-line eqeqeq
    } else if (articleType == 4) {
      articleUrl = '/link_detail?newsid=' + articleID + '_' + sid
      // eslint-disable-next-line eqeqeq
    } else if (articleType == 5) {
      articleUrl = '/news_detail?newsid=' + articleID + '_' + sid
      // eslint-disable-next-line eqeqeq
    } else if (articleType == 6) {
      articleUrl = '/live_detail?newsid=' + articleID + '_' + sid
      // eslint-disable-next-line eqeqeq
    } else if (articleType == 7) {
      articleUrl = '/news_detail?newsid=' + articleID + '_' + sid
      // eslint-disable-next-line eqeqeq
    } else if (articleType == 8) {
      articleUrl = '/adv_detail?newsid=' + articleID + '_' + sid
      // eslint-disable-next-line eqeqeq
    } else if (articleType == 20) {
      articleUrl = '/activeInfo/' + linkID + '_' + sid + '.html'
      // eslint-disable-next-line eqeqeq
    } else if (articleType == 21) {
      articleUrl = '/detailsvd/' + articleID + '_' + columnID + '_' + sid + '.html'
      // eslint-disable-next-line eqeqeq
    } else if (articleType == 22) {
      articleUrl = '/audioInfo/' + articleID + '_' + columnID + '_' + 1 + '_' + sid + '.html'
      // eslint-disable-next-line eqeqeq
    } else if (articleType == 25) {
      articleUrl = '/news_detail?newsid=' + articleID + '_' + sid
      // eslint-disable-next-line eqeqeq
    } else if (articleType == 104) {
      articleUrl = '/topicColumn/' + sid + '/' + articleID
      // eslint-disable-next-line eqeqeq
    } else if (articleType == 'column') {
      articleUrl = '/column_view?cid=' + columnID + '&sid=' + sid
    } else {
      articleUrl = '/news_detail?newsid=' + articleID + '_' + sid
    }
    return articleUrl
  }
})




// WEBPACK FOOTER //
// ./src/tool/utils.js